import { createAction } from 'redux-action';

export const ROUTE = 'promotion/ROUTE';

export default createAction(ROUTE);
